export const EM_AUTOMATION_SCRIPTS_SLICE_NAME = '@@emAutomationScripts';
